<template>
    <internal>
        <div class="p-6 bg-white border-b border-gray-200 shadow-sm sm:rounded-lg">
            <loading :showLoading="form.processing"/>
            <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">
                <p class="text-lg font-medium mb-4">Edit Workshop</p>
                <form @submit.prevent="submitForm">
                    <div class="grid grid-cols-8 gap-4 mb-8">
                        <div class="col-span-4 sm:col-span-4">
                            <breeze-label :required="true" :value="'Title'"/>
                            <breeze-input required class="w-full" v-model="form.title"/>
                            <breeze-input-error :message="form.errors?form.errors.title:''"/>
                        </div>
                        <div class="col-span-4 sm:col-span-4">
                            <breeze-label :required="true" :value="'Faculty Name'"/>
                            <breeze-input required class="w-full" v-model="form.faculty_name"/>
                            <breeze-input-error :message="form.errors?form.errors.faculty_name:''"/>
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :required="true" :value="'Amount'"/>
                            <breeze-input required type="number" class="w-full" v-model="form.amount"/>
                            <breeze-input-error :message="form.errors?form.errors.amount:''"/>
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :required="true" :value="'Deadline'"/>
                            <breeze-input required type="date" class="w-full" v-model="form.deadline_at"/>
                            <breeze-input-error :message="form.errors?form.errors.deadline_at:''"/>
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :required="true" :value="'Workshop At'"/>
                            <breeze-input required type="date" class="w-full" v-model="form.workshop_at"/>
                            <breeze-input-error :message="form.errors?form.errors.workshop_at:''"/>
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <a :href="'/'+form.photo" target="_blank">
                                <breeze-label  :value="'Photo'"/>
                            </a>
                            <breeze-input  type="file" class="w-full" @input="form.photo = $event.target.files[0]" accept=".png, .jpg, .jpeg, .webp"/>
                            <breeze-input-error :message="form.errors?form.errors.photo:''"/>
                        </div>

                        <div class="col-span-8 sm:col-span-8">
                            <breeze-label :required="true" :value="'Details'"/>
                            <vue-editor id="editor" v-model="form.details"></vue-editor>
                            <breeze-input-error :message="form.errors?form.errors.details:''"/>
                        </div>
                        <div class="col-span-4 sm:col-span-4 space-y-4">
                            <div class="grid grid-cols-5 items-center gap-x-4" v-for="(cls,index) in form.classes"
                                 :key="index">
                                <div class="col-span-4 sm:col-span-4">
                                    <FormMultiselect
                                        label="Course Year"
                                        :options="options"
                                        track-key="id"
                                        label-key="title"
                                        :object="true"
                                        :required="true"
                                        v-model="form.classes[index]"
                                        placeholder="Select Course Year"
                                        :error="form.errors.courseyear"
                                    />
                                </div>
                                <div class="col-span-1 pt-4">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7 text-red-500 cursor-pointer"
                                         viewBox="0 0 20 20" fill="currentColor" @click="removeRecord(index)">
                                        <path fill-rule="evenodd"
                                              d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                              clip-rule="evenodd"/>
                                    </svg>
                                </div>
                                <div class="col-span-5">
                                    <InputError :message="form.errors[`classes.${index}.id`]"/>
                                </div>
                            </div>
                            <breeze-button type="button" class="mt-4" @click="addRecord()">Add Course Years
                            </breeze-button>
                            <breeze-input-error :message="form.errors?form.errors.classes:''"/>
                        </div>
                        <div>
                            <breeze-label :value="'Status'"/>
                            <breeze-checkbox v-model="form.status" :checked="form.status"/>
                            <breeze-input-error :message="form.errors?form.errors.status:''"/>
                        </div>
                    </div>
                    <button-link :href="route('internal.workshop.list',branchid)"
                                 class="bg-red-500 mr-4 hover:bg-red-400">Cancel
                    </button-link>
                    <breeze-button :disabled="form.processing">Submit</breeze-button>
                    <span v-if="form.recentlySuccessful" class="text-green-500 mx-4">Workshop Added!</span>
                    <exception/>
                </form>
            </div>
        </div>
    </internal>
</template>

<script>
import Internal from '@/Pages/Internal/Internal'
import BreezeInput from '@/Components/Input'
import BreezeLabel from '@/Components/Label'
import ButtonLink from '@/Components/ButtonLink'
import CardHeader from '@/Components/CardHeader'
import {useForm} from '@inertiajs/inertia-vue3'
import BreezeInputError from '@/Components/InputError'
import BreezeButton from '@/Components/Button'
import BreezeCheckbox from '@/Components/Checkbox'
import Loading from '@/Components/Loading'
import SelectList from '@/Components/SelectList'
import Exception from '@/Components/Exception'
import BreezeTable from '@/Components/Table'
import {VueEditor} from "vue3-editor";
import FormMultiselect from "@/Components/Forms/FormMultiselect.vue";
import InputError from "@/Components/InputError.vue";

export default {
    components: {
        InputError,
        FormMultiselect,
        Internal,
        BreezeInput,
        BreezeLabel,
        ButtonLink,
        CardHeader,
        BreezeInputError,
        BreezeButton,
        BreezeCheckbox,
        Loading,
        Exception,
        BreezeTable,
        SelectList,
        VueEditor
    },
    props: ['courseyears', 'workshop'],
    data() {
        return {
            form: useForm({
                '_method': 'PUT',
                title: this.workshop.title,
                photo: this.workshop.image,
                deadline_at: this.workshop.deadline_at,
                workshop_at: this.workshop.workshop_at,
                amount: this.workshop.amount,
                faculty_name: this.workshop.faculty_name,
                classes: this.convertOption(this.workshop.classes),
                details: this.workshop.details,
                status: this.workshop.status,
            }),
            branchid: localStorage.branchId,
        }
    },
    methods: {
        submitForm() {
            this.form.post(route('internal.workshop.update', [this.branchid, this.workshop.id]));
        },
        addRecord() {
            this.form.classes.push({courseyear: ''})
        },
        removeRecord(index) {
            this.form.classes.splice(index, 1);
        },
        convertOption(classes) {
            const courseyear = [];
            classes.forEach(cls => {
                courseyear.push({
                    id: cls.courseyear.id,
                    title: cls.courseyear.course.title + ' - ' + cls.courseyear.title + ' - ' + cls.courseyear.duration.start_month
                });
            });
            return courseyear;
        }
    },
    computed: {
        options() {
            var options = [];
            this.courseyears.forEach(courseyear => {
                options.push({
                    id: courseyear.id,
                    title: courseyear.course.title + ' - ' + courseyear.title + ' - ' + courseyear.duration.start_month
                });
            });
            return options;
        },
    },
}
</script>
<style>
#editor {
    height: 400px;
}
</style>
